import React, { useEffect, useRef } from 'react';
import classnamesBind from 'classnames/bind';
import IconButton from '@concur/nui-widgets/lib/IconButton/IconButton';
import { onBisClose } from '../utils/builtInSupport';
import styles from './Shellbar.css';

const CSS_BLOCK = 'sapcnqr-shellbar';

const BISMenuItem = () => {
    const buttonRef = useRef(null);

    useEffect(() => {
        return onBisClose(() => buttonRef.current?.focus());
    }, []);

    const classnames = classnamesBind.bind(styles);

    const handleClick = () => {
        const sdkGlobal = window['sdk-react-dsx-everywhere'];
        if (sdkGlobal?.isWindowOpened()) {
            sdkGlobal.closeWindow();
        } else {
            sdkGlobal?.openWindow();
        }
    };

    return (
        <li className={classnames(`${CSS_BLOCK}__listitem`)} role="none">
            <IconButton
                ref={buttonRef}
                ariaLabel="Built-In Support"
                iconName="headset"
                tooltipProps={{ outerPopperProps: { showArrow: false } }}
                iconProps={{
                    className: classnames(`${CSS_BLOCK}__icon-button`),
                }}
                onClick={() => handleClick()}
            />
        </li>
    );
};

BISMenuItem.displayName = 'BISMenuItem';

export default BISMenuItem;
